export const SET_WORK_ORDER = 'SET_WORK_ORDER'
export const RESET_WORK_ORDER = 'RESET_WORK_ORDER'
export const SET_FOLLOW_UP_FLOW = 'SET_FOLLOW_UP_FLOW'
